import { Component } from 'react';
import ErrorPage from 'pages/ErrorPage';
import { captureErrorInSentry } from 'lib/captureInSentry';

class ErrorBoundary extends Component {
  state = { error: null };

  componentDidCatch(error, info) {
    captureErrorInSentry(error, { info });
    this.setState({ error });
  }

  render() {
    if (this.state.error) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
